import Url from '@mc/mc-utils/js/url/url'

export const getCmsPreviewKey = () => {
  const url = new Url(window.location.href)
  const query = url.parseQuerystring()
  const hashQuery = url.Hash ? url.Hash.parseQuerystring() : {}
  return query.cms_preview_key || hashQuery.cms_preview_key || ''
}
